import React from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  return <motion.nav initial={{
    y: -20,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-black" data-id="element-74">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-75">
        <div className="flex items-center" data-id="element-76">
          <img src="https://cdn.magicpatterns.com/uploads/2FTbScxatEFYg46cgjnota/logo_1.1.png" alt="AI Pilot Society by Andres Castro" className="h-12 w-auto" data-id="element-77" />
        </div>

        <button onClick={() => document.getElementById('cta')?.scrollIntoView({
        behavior: 'smooth'
      })} className="px-6 py-2.5 rounded-full bg-brand-cyan text-black font-bold text-sm transition-all duration-300 btn-glow-cyan hover:bg-brand-cyan/90" data-id="element-78">
          Obtén Guía 1K Gratis
        </button>
      </div>
    </motion.nav>;
}